export default "__VITE_ASSET__DJANGTXt__"